import React, { useMemo } from "react";
import SelectOption from "./components/SelectOption";

// originalMaterialExperienceOptions
const OMEOptions = [
  {
    value: "あり",
    label: "あり(国内市販実績のある成分・濃度を使用し、厚生労働省の化粧品基準に従っている。）",
  },
  {
    value: "なし",
    label: "なし (以下から選択してください。)",
    subOptions: [
      {
        value: "国内市販実績のない新規成分を使用している",
        label: "国内市販実績のない新規成分を使用している",
      },
      {
        value: "国内市販実績のある成分だが、実績のない高濃度を配合している、または原料の場合、希釈後の試験濃度が国内市販実績のない高濃度である",
        label: "国内市販実績のある成分だが、実績のない高濃度を配合している、または原料の場合、希釈後の試験濃度が国内市販実績のない高濃度である",
      },
      {
        value: "ヒト由来の原料を使用している",
        label: "ヒト由来の原料を使用している",
      },
    ],
  },
];

function SelectMultiSubOption(props) {
  const { selectedSubValues, onSelect, handleSelect, isReadonly } = props;

  const isSelectedOption = useMemo(() => {
    return selectedSubValues.find(
      (item) =>
        item === OMEOptions[1].subOptions[0].value ||
        item === OMEOptions[1].subOptions[1].value ||
        item === OMEOptions[1].subOptions[2].value
    );
  }, [selectedSubValues]);

  const handleSelectOption = (value) => {
    if (!isSelectedOption) {
      onSelect(
        [
          ...selectedSubValues,
          OMEOptions[1].subOptions[0].value,
          OMEOptions[1].subOptions[1].value,
          OMEOptions[1].subOptions[2].value,
        ].join("|")
      );
    } else {
      onSelect(
        selectedSubValues
          .filter(
            (item) =>
              ![
                OMEOptions[1].subOptions[0].value,
                OMEOptions[1].subOptions[1].value,
                OMEOptions[1].subOptions[2].value,
              ].includes(item)
          )
          .join("|")
      );
    }
  };

  const handleSelectSubOption = (subValue) => {
    handleSelect(subValue);
  };

  return (
    <div className="w-full h-auto">
      <div className="w-full h-full flex flex-col justify-center gap-2.5 relative">
        <SelectOption
          label={
            <p className="w-full text-start px-3">{OMEOptions[1].label}</p>
          }
          value={OMEOptions[1].value}
          onSelect={handleSelectOption}
          isSelected={isSelectedOption}
          width="100%"
          isReadonly={isReadonly}
          className="text-start"
        />
        <div className="w-full h-auto flex items-center pl-[30px]">
          <div className="w-[22px] h-full flex items-center">
            <div className="w-full h-[2px] bg-[#6C6C6C]"></div>
            <div className="w-0 h-0 border-t-4 border-t-transparent  border-b-4 border-b-transparent border-l-4 border-l-[#6C6C6C]"></div>
          </div>
          <div className="w-[calc(100%-22px)]">
            <SelectOption
              label={
                <p className="w-full text-start px-3">
                  {OMEOptions[1].subOptions[0].label}
                </p>
              }
              value={OMEOptions[1].subOptions[0].value}
              onSelect={handleSelectSubOption}
              isSelected={selectedSubValues.includes(
                OMEOptions[1].subOptions[0].value
              )}
              width="100%"
              isReadonly={isReadonly}
            />
          </div>
        </div>

        <div className="w-full h-auto flex items-center pl-[30px]">
          <div className="w-[22px] h-full flex items-center">
            <div className="w-full h-[2px] bg-[#6C6C6C]"></div>
            <div className="w-0 h-0 border-t-4 border-t-transparent  border-b-4 border-b-transparent border-l-4 border-l-[#6C6C6C]"></div>
          </div>
          <div className="w-[calc(100%-22px)]">
            <SelectOption
              label={
                <p className="w-full text-start px-3">
                  {OMEOptions[1].subOptions[1].label}
                </p>
              }
              value={OMEOptions[1].subOptions[1].value}
              onSelect={handleSelectSubOption}
              isSelected={selectedSubValues.includes(
                OMEOptions[1].subOptions[1].value
              )}
              width="100%"
              isReadonly={isReadonly}
            />
          </div>
        </div>

        <div className="w-full h-auto flex items-center pl-[30px]">
          <div className="w-[22px] h-full flex items-center">
            <div className="w-full h-[2px] bg-[#6C6C6C]"></div>
            <div className="w-0 h-0 border-t-4 border-t-transparent  border-b-4 border-b-transparent border-l-4 border-l-[#6C6C6C]"></div>
          </div>
          <div className="w-[calc(100%-22px)]">
            <SelectOption
              label={
                <p className="w-full text-start px-3">
                  {OMEOptions[1].subOptions[2].label}
                </p>
              }
              value={OMEOptions[1].subOptions[2].value}
              onSelect={handleSelectSubOption}
              isSelected={selectedSubValues.includes(
                OMEOptions[1].subOptions[2].value
              )}
              width="100%"
              isReadonly={isReadonly}
            />
          </div>
        </div>

        <div className="absolute top-[30px] left-[30px] bottom-[14px] w-0.5 bg-[#6C6C6C]"></div>
      </div>
    </div>
  );
}

function SelectOriginalMaterialExperience(props) {
  const { selectedValue, onSelect, isReadonly } = props;

  const selectedSubValues = useMemo(() => {
    if (!selectedValue || typeof selectedValue !== "string") return [];

    return selectedValue.split("|").filter((item) => item);
  }, [selectedValue]);

  const handleSelect = (value) => {
    if (selectedSubValues.includes(value)) {
      onSelect(selectedSubValues.filter((item) => item !== value).join("|"));
    } else {
      onSelect([...selectedSubValues, value].join("|"));
    }
  };

  return (
    <div className="w-full h-full border border-solid border-[#B3B3B3] bg-white rounded-[10px]">
      <div className="w-full h-full flex flex-col justify-center gap-2.5 p-2">
        <SelectOption
          label={
            <p className="w-full text-start px-3">{OMEOptions[0].label}</p>
          }
          value={OMEOptions[0].value}
          onSelect={handleSelect}
          isSelected={selectedSubValues.includes(OMEOptions[0].value)}
          width="100%"
          isReadonly={isReadonly}
        />
        <SelectMultiSubOption
          selectedSubValues={selectedSubValues}
          onSelect={onSelect}
          handleSelect={handleSelect}
          isReadonly={isReadonly}
        />
        <div className="pt-2 self-start text-xs text-[#707070]">
          ※選択内容によっては、倫理審査委員会での承認後の実施、または実施できない可能性がございます。
        </div>
      </div>
    </div>
  );
}

export default SelectOriginalMaterialExperience;
